export default {
  configCollaborateurs_pending: false,
  configCollaborateurs: []
}
